module.exports = __webpack_public_path__ + "static/media/image78.7c48ba3d.png";